import { render, staticRenderFns } from "./SettingsSideBar.vue?vue&type=template&id=8fe7a7f2&"
import script from "./SettingsSideBar.vue?vue&type=script&lang=js&"
export * from "./SettingsSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports